module.exports = __webpack_public_path__ + "static/media/ptbi-logo@2x.389bf47c.png";